module.exports = __webpack_public_path__ + "img/1728435076145-Screenshot_9-10-2024_84828_klik-online.com.jpeg.aef0e543.webp";